import DEPART_CITY_DIC from '../constants/DepartCity';
import { encodeObject } from './encodedObject';

export const getTourData = (hotel, departure, request_model) => {
  const [tour] = hotel.tours.tour;
  if (!tour) {
    return '';
  }
  const data = {
    provider: 'tourvisor',
    offer_id: tour.tourid,
    depart_id: departure,
    depart_name: DEPART_CITY_DIC[departure]
      ? DEPART_CITY_DIC[departure].name
      : '',
    country_id: hotel.countrycode,
    country_name: hotel.countryname,
    town_id: hotel.regioncode,
    town_name: hotel.regionname,
    hotel_id: hotel.hotelcode,
    hotel_name: hotel.hotelname,
    hotel_description: 'oneTour',
    hotel_image_src: hotel.picturelink,
    hotel_link: hotel.fulldesclink,
    hotel_adult: tour.adults,
    hotel_child: tour.child,
    star_id: hotel.hotelstars ? hotel.hotelstars : '',
    star_name: hotel.hotelstars ? `${hotel.hotelstars}*` : '',
    meal_id: tour.mealcode,
    meal_name: tour.meal,
    room_id: tour.room,
    room_name: tour.room,
    place_id: tour.placement,
    place_name: tour.placement,
    dt1: tour.flydate,
    dt2: tour.flydate,
    nights: tour.nights,
    adult: request_model.adults,
    child: request_model.child,
    oper_id: tour.operatorcode,
    oper_name: tour.operatorname,
    price: tour.price,
    currency: tour.currency,
    claim_mark: 'customer',
    credit: false,
  };

  return encodeObject(data);
};
